import { TableHeader } from "./types";

export const initialTableHeaderState: TableHeader = {
  heads: {},
  headKey: [],
  headsMaster: null,
  headKeyMaster: null,
  changedColumnWidthIndex: null,
};
